module.exports = __webpack_public_path__ + "article-7051a3ee/westend61-a35a9358c4fa2bf61295e722995289d7.jpg";